
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/certification-prep/[[...slug]]",
      function () {
        return require("private-next-pages/browse/certification-prep/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/certification-prep/[[...slug]]"])
      });
    }
  